import { useQuery } from '@tanstack/react-query';
import { CatalogAPI } from '@base/api/catalog-api';
import { queryKeys } from './queries';

const catalogAPI = new CatalogAPI();

export function useDefectCatalog(itemCode: string, serialNo?: string) {
  return useQuery({
    queryKey: queryKeys.catalog(itemCode, serialNo),
    queryFn: () => catalogAPI.getDefectCatalog(itemCode, serialNo),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!itemCode,
  });
}

export function useComponentCatalog(itemCode: string) {
  return useQuery({
    queryKey: queryKeys.componentCatalog(itemCode),
    queryFn: () => catalogAPI.getComponentDefectCatalog(itemCode),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!itemCode,
  });
}
